import type { UniqueIdentifier } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import UntitledIcon from '@payaca/untitled-icons';
import { clstx } from '@payaca/utilities/cvaMerge';
import type { FC } from 'react';

interface Props {
  id: UniqueIdentifier;
  as?: 'button' | 'div';
  className?: string;
  label: string;
}

const DragHandle: FC<Props> = (props) => {
  const { id, as: Element = 'button', className, label } = props;
  const { attributes, listeners, setActivatorNodeRef, isDragging } =
    useSortable({ id });

  return (
    <Element
      ref={setActivatorNodeRef}
      aria-label={`Reorder: ${label}`}
      className={clstx(
        'bg-transparent p-0 flex items-center justify-center cursor-grab hover:bg-gray-100 rounded',
        isDragging && 'cursor-grabbing',
        className
      )}
      {...(Element === 'button'
        ? { type: 'button' }
        : { role: 'button', onClick: (e) => e.stopPropagation() })}
      {...attributes}
      {...listeners}
    >
      <UntitledIcon name="draggable" className="size-6" />
    </Element>
  );
};

export default DragHandle;
